import React, { useEffect, useState, useRef } from "react";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import { faEdit, faEye, faDeleteLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module-react";
const MySwal = withReactContent(Swal2);
Quill.register("modules/imageResize", ImageResize);

const AdminPanelCourtMailTemplate = (props) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");
  const [subject, setSubject] = useState("");
  const [template, setTemplate] = useState("");
  const [poz, setPoz] = useState("");
  const [templateName, setTemplateName] = useState("");

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ color: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" },
      ],
      ["link", "image"],
    ],
    imageResize: {
      parchment: Quill.import("parchment"),
      modules: ["Resize", "DisplaySize"],
    },
    clipboard: {
      matchVisual: false,
    },
  };

  const handleTemplateChange = (e) => {
    setTemplate(e.target.value);
    if (e.target.value === "new") {
      var content = "";
      var subject = "";
    } else {
      var content = templates.filter((el) => +el.id === +e.target.value)[0]
        .content;
      var subject = templates.filter((el) => +el.id === +e.target.value)[0]
        .subject;
      var poz = templates.filter((el) => +el.id === +e.target.value)[0].poz;
    }

    setValue(content);
    setSubject(subject);
    setPoz(poz);
  };

  const fetchResults = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getCourtMailTemplates", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTemplates(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchResults();
  };

  useEffect(() => {
    getData();
  }, []);

  const sendTemplate = (e) => {
    if (template) {
      if (template === "new") {
        addTemplate();
      } else {
        updateTemplate();
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wybierz",
        text: "szablon wiadomości",
      }).then(async (result) => {});
    }
  };

  const updateTemplate = async () => {
    var body = {
      id: template,
      subject: subject,
      content: value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/updateCourtMailTemplate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Edytowano",
          text: "szablon wiadomości",
        }).then((result) => {
          getData();
        });
      });
  };

  const addTemplate = async () => {
    var body = {
      name: templateName,
      subject: subject,
      content: value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertCourtMailTemplate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "szablon wiadomości",
        }).then((result) => {
          getData();
        });
      });
  };

  const deleteTemplate = async () => {
    var body = {
      id: template,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteCourtMailTemplate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Usunięto",
          text: "szablon wiadomości",
        }).then((result) => {
          getData();
        });
      });
  };

  const updateTemplatePoz = async () => {
    MySwal.fire({
      title: "Wprowadź nową wartość",
      input: "text",
      inputPlaceholder: poz,
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz podać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var value = result.value;
        var body = {
          id: template,
          poz: value,
        };

        await fetch(
          "https://apidevkppp.ftpeople.pl/updateCourtMailTemplatePoz",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          }
        )
          .then((response) => response.text())
          .then((data) => {
            MySwal.fire({
              icon: "success",
              title: "Edytowano",
              text: "szablon wiadomości",
            }).then((result) => {
              getData();
            });
          });
      }
    });
  };

  return (
    <div className="mainContainerPayments">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div
            style={{ width: "75%" }}
            id="addPaymentIC"
            className="inputContainer"
          >
            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Wybierz szablon <span className="requiredStar">*</span>
                </label>
                <select
                  type="text"
                  id="court"
                  name="court"
                  value={template}
                  onChange={handleTemplateChange}
                >
                  {!template ? (
                    <option key={0} value="0">
                      Wybierz...
                    </option>
                  ) : (
                    ""
                  )}
                  {templates.map((el) => (
                    <>
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    </>
                  ))}
                  <option key={"0x"} value={"new"}>
                    {"Nowy szablon"}
                  </option>
                </select>
              </div>
            </div>
            {template === "new" ? (
              <>
                <div style={{ marginTop: "3vh" }}>
                  <label>Nazwa szablonu</label>
                  <input
                    type="text"
                    id="signature"
                    name="signature"
                    value={templateName}
                    onChange={(e) => {
                      setTemplateName(e.target.value);
                    }}
                  />
                </div>
              </>
            ) : (
              ""
            )}
            <div style={{ marginTop: "3vh" }}>
              <label>Temat wiadomości</label>
              <input
                type="text"
                id="signature"
                name="signature"
                value={subject}
                onChange={(e) => {
                  setSubject(e.target.value);
                }}
              />
            </div>
            <label style={{ marginTop: "2vh" }}>Wiadomość</label>
            <div
              style={{
                marginTop: "1vh",
                border: "1px solid black",
                borderRadius: "15px",
              }}
            >
              <ReactQuill
                theme="snow"
                value={value}
                onChange={setValue}
                modules={modules}
              />
            </div>

            <div style={{ display: "flex", gap: "20px" }} className="saveBoxAP">
              {template.length > 0 ? (
                <>
                  <button className="paymentMenuButton" onClick={sendTemplate}>
                    Zapisz
                  </button>
                </>
              ) : (
                ""
              )}

              {template.length > 0 && template !== "new" ? (
                <>
                  <button
                    className="paymentMenuButton"
                    onClick={deleteTemplate}
                  >
                    Usuń
                  </button>
                </>
              ) : (
                ""
              )}
            </div>
            <div>
              {template.length > 0 && template !== "new" ? (
                <>
                  <p>Pozcja na liście {poz}</p>

                  <button
                    className="paymentMenuButton"
                    onClick={updateTemplatePoz}
                  >
                    Zmień pozycję na liście
                  </button>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminPanelCourtMailTemplate;
